module.exports = __webpack_public_path__ + "static/media/bottle-02.8bb0e278.png";